'use client';

import { useRef } from 'react';
import { ExternalLink } from 'lucide-react';
import Image from 'next/image';
import PartnerCarousel from "@/components/sections/PartnerCarousel";

export default function ImpactFooter() {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <section className="py-20 bg-ivory relative overflow-hidden">
      <div className="container-custom">
        <div ref={ref} className="relative">
          <div className="text-center mb-16">
            <h2 className="heading-2 text-oxford mb-4">
              Join Us in Creating Change
            </h2>
            <p className="body-text text-oxford/80 max-w-3xl mx-auto">
              At Micro Leaps, we're committed to transforming the educational journey for underprivileged children across India. <strong className="text-dark-peach">We need your support to reach our 2025 goals.</strong>
            </p>
          </div>

          {/* CTA Section (Informational) */}
          <div className="bg-mid-blue text-ivory p-8 md:p-12 rounded-lg text-center mb-16 shadow-xl">
            <h3 className="font-heading text-2xl mb-4">Our Mission & Impact</h3>
            <p className="text-ivory/90 mb-8 max-w-2xl mx-auto">
              Your support helps us provide quality education, essential resources, and a pathway to dignified employment for underprivileged children.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-8">
              <div className="bg-white/10 p-6 rounded-lg backdrop-blur-sm border border-white/5 transition-transform hover:scale-105">
                <p className="text-ivory font-heading text-xl mb-1">₹2,500/month</p>
                <p className="text-ivory/80 text-sm">Support a Child's Education</p>
              </div>
              <div className="bg-white/10 p-6 rounded-lg backdrop-blur-sm border border-white/5 transition-transform hover:scale-105">
                <p className="text-ivory font-heading text-xl mb-1">₹10,000/month</p>
                <p className="text-ivory/80 text-sm">Stationary & Technology Cost</p>
              </div>
              <div className="bg-white/10 p-6 rounded-lg backdrop-blur-sm border border-white/5 transition-transform hover:scale-105">
                <p className="text-ivory font-heading text-xl mb-1">₹25,000/month</p>
                <p className="text-ivory/80 text-sm">Support a Class</p>
              </div>
            </div>
            <p className="text-ivory/70 text-sm italic">
              Transparency: 100% of our funds go directly toward student programs and learning materials.
            </p>
          </div>


          {/* Partner Logos */}
          <div className="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw]">
            <PartnerCarousel />
          </div>
          {/* Inspirational Quote */}
          <div
            className="text-center mt-16 max-w-3xl mx-auto"
          >
            <blockquote className="text-xl md:text-2xl font-heading text-oxford italic">
              "Education is not the filling of a pail, but the lighting of a fire."
            </blockquote>
            <p className="text-oxford/70 mt-2">— William Butler Yeats</p>
          </div>
        </div>
      </div>
    </section>
  );
}